import { Component, OnInit, Input } from '@angular/core';

import { DraggableService } from '../../_services/draggable.service';

@Component({
  selector: 'app-draggable-popup',
  templateUrl: './draggable-popup.component.html',
  styleUrls: ['./draggable-popup.component.scss']
})
export class DraggablePopupComponent implements OnInit {

  showPopup = false;

  title: any;
  message: any;
  buttonName: any;

  constructor(
    public draggableService: DraggableService,
  ) { }

  ngOnInit() {
    this.draggableService.showDragEvent.subscribe( data => {
      this.buttonName = data.buttonName ? data.buttonName : 'Close';
      this.message = data.content;
      this.title = data.title;
      this.showPopup = true;
    });
  }

  pressCloseButton() {
    this.showPopup = false;
  }

}
